var GeoPoint = /** @class */ (function () {
    function GeoPoint(inputData) {
        var data = inputData || {};
        this.lat = data['lat'];
        this.lon = data['lon'];
    }
    return GeoPoint;
}());
export { GeoPoint };
//# sourceMappingURL=geo-point.js.map